import * as React from "react"
import { createContext, forwardRef, useContext } from "react"
import { FixedSizeList } from "react-window"

export const ROW_HEIGHT = 40
export const MAX_VISIBLE_ROWS = 8

// ─── Virtualized listbox ───
// The site catalog runs into the hundreds (883 in puig). MUI's Autocomplete
// renders every option into the DOM, and each of our rows is an <li> + a
// Checkbox (SVG + ripple) + a flag icon — thousands of nodes on a single open,
// which is what made the dropdown stutter. react-window keeps only the visible
// rows mounted. The full catalog stays in memory so "Select All" and the
// client-side text filter still cover all of it.

const OuterElementContext = createContext({})

const OuterElement = forwardRef(function OuterElement(props, ref) {
    const outerProps = useContext(OuterElementContext)
    return <div ref={ref} {...props} {...outerProps} />
})

const VirtualizedListbox = forwardRef(function VirtualizedListbox(props, ref) {
    const { children, ...other } = props
    const items = React.Children.toArray(children)
    const height = Math.min(items.length, MAX_VISIBLE_ROWS) * ROW_HEIGHT

    return (
        <div ref={ref}>
            <OuterElementContext.Provider value={other}>
                <FixedSizeList
                    height={height}
                    width="100%"
                    itemCount={items.length}
                    itemSize={ROW_HEIGHT}
                    itemData={items}
                    outerElementType={OuterElement}
                    innerElementType="ul"
                    overscanCount={5}
                >
                    {({ data, index, style }) =>
                        React.cloneElement(data[index], { style: { ...style, margin: 0 } })
                    }
                </FixedSizeList>
            </OuterElementContext.Provider>
        </div>
    )
})

export default VirtualizedListbox
